import { DashboardView } from './schemas.js';
export const adminAnalyticsRoutes = {
    dashboard: { method: 'GET', path: '/admin/dashboard', response: DashboardView },
};
//# sourceMappingURL=routes.js.map